import React from "react";

class Array extends React.Component
{
    static pluck(objs, name) {
        var sol = [];
        for(var i in objs){
            if(objs[i].hasOwnProperty(name)){
                sol.push(objs[i][name]);
            }
        }
        return sol;
    }

    render() {
        return (
            <>
            </>
        )
    }
}

export default Array;
